import React, { useState, useEffect } from 'react';
import Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-jsx';
import './GraduateTextComponent.css';

const processMessageContent = (content) => {
  const codeBlockRegex = /<pre><code>([\s\S]*?)<\/code><\/pre>/g;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = codeBlockRegex.exec(content)) !== null) {
    if (match.index > lastIndex) {
      parts.push({
        type: 'text',
        content: content.slice(lastIndex, match.index)
      });
    }
    parts.push({
      type: 'code',
      content: match[1]
    });
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < content.length) {
    parts.push({
      type: 'text',
      content: content.slice(lastIndex)
    });
  }

  return parts;
};

const CodeBlock = ({ code }) => {
  useEffect(() => {
    Prism.highlightAll();
  }, [code]);

  return (
    <pre className="code-block">
      <code className="language-javascript">
        {code}
      </code>
    </pre>
  );
};

const GradualTextComponent = ({ text, wordsPerStep = 10, stepInterval = 1000 }) => {
  const [displayedParts, setDisplayedParts] = useState([]);
  const parts = processMessageContent(text);

  useEffect(() => {
    let currentPartIndex = 0;
    let currentWordIndex = 0;
    
    const intervalId = setInterval(() => {
      if (currentPartIndex < parts.length) {
        const currentPart = parts[currentPartIndex];
        
        if (currentPart.type === 'code') {
          // Add entire code block at once
          setDisplayedParts(prev => [...prev, currentPart]);
          currentPartIndex++;
        } else {
          // For text parts, add words gradually
          const words = currentPart.content.split(' ');
          const endIndex = Math.min(currentWordIndex + wordsPerStep, words.length);
          const partialContent = words.slice(0, endIndex).join(' ');
          
          setDisplayedParts(prev => {
            const newParts = [...prev];
            if (prev[currentPartIndex]?.type === 'text') {
              newParts[currentPartIndex] = { type: 'text', content: partialContent };
            } else {
              newParts.push({ type: 'text', content: partialContent });
            }
            return newParts;
          });
          
          currentWordIndex += wordsPerStep;
          if (currentWordIndex >= words.length) {
            currentPartIndex++;
            currentWordIndex = 0;
          }
        }
      } else {
        clearInterval(intervalId);
      }
    }, stepInterval);

    return () => clearInterval(intervalId);
  }, [text, wordsPerStep, stepInterval]);

  return (
    <div>
      {displayedParts.map((part, index) => (
        part.type === 'code' ? (
          <CodeBlock key={index} code={part.content} />
        ) : (
          <span key={index} dangerouslySetInnerHTML={{ __html: part.content }} />
        )
      ))}
    </div>
  );
};

export default GradualTextComponent;